import {
    ICadastrarVisita,
    ICompromissoRequest,
    IPontoVendaResponse,
} from "../../../Interfaces/Vendas/Compromisso/CompromissoInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function CompromissoVendasService(
    requestBody: ICompromissoRequest
) {
    return Service(AxiosVendas.post(`/app/compromisso`, requestBody));
}

export async function ListarPontosVendaService() {
    return Service(
        AxiosVendas.get<Array<IPontoVendaResponse>>(
            `/app/compromisso/listarpontovenda`
        )
    );
}

export async function ListarPorLeadVendasService(
    idLead: number,
    dtCompromissos: string
) {
    return Service(
        AxiosVendas.post(
            `/app/compromisso/listarporlead?idLead=${idLead}&dtCompromissos=${dtCompromissos}`
        )
    );
}

export async function CadastrarVisitaVendasService(
    requestBody: ICadastrarVisita
) {
    return Service(
        AxiosVendas.post(`/app/compromisso/cadastrarvisita`, requestBody)
    );
}

export async function DeletarVisitaVendasService(ID_CASO_VISITA: number) {
    return Service(
        AxiosVendas.delete(
            `/app/compromisso/deletarvisita?ID_CASO_VISITA=${ID_CASO_VISITA}`
        )
    );
}
